import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('about_title')}
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>{t('about_p1')}</p>
              <p>{t('about_p2')}</p>
              <p>{t('about_p3')}</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#1e3a8a] rounded-lg mx-auto mb-3">
                  <i className="ri-database-2-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm">{t('about_feature1')}</h4>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#1e3a8a] rounded-lg mx-auto mb-3">
                  <i className="ri-eye-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm">{t('about_feature2')}</h4>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#1e3a8a] rounded-lg mx-auto mb-3">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm">{t('about_feature3')}</h4>
              </div>
            </div>
          </div>

          <div className="relative h-[600px] w-full rounded-xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/e3e15620864d7cf570f906cb3383c959.jpg"
              alt="Land consultancy services in Sicily"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
